import { React, useState } from 'react';
import {
  BlockTypeRenderer,
  Block as ContentAreaRenderer,
} from '../../platformui/Base/Render';
import { sanitizeUrlParam } from '../../platformui/Helpers/helpers';
import { TabBlock } from '../tab-block';
//To be removed when moving to Opti 12 in favor of IDS module import';
import './tab-container-block.scss';
import { useEffect } from 'react';
import { isMediumViewport } from '../../platformui/Hooks/useMedia';

const Blocks = {
  TabBlock,
};

/**
 * @typedef {Object} TabBlockType
 * @property {string} TabHeading - The tab's heading.
 */

/**
 * @typedef {Object} TabContainerBlockProps
 * @property {TabBlockType[]} MainContent - Array of tab blocks.
 */

/**
 * Renders a tab container with selectable tabs.
 *
 * @param {TabContainerBlockProps} props
 * @returns {JSX.Element|null}
 */
export const TabContainerBlock = (props) => {
  const { MainContent } = props;

  if (!MainContent || MainContent.length === 0) {
    return null;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const initialTabParam = urlParams.get('selectedTab') || null;

  const initialTab = initialTabParam
    ? MainContent.findIndex(
      (block) => sanitizeUrlParam(block.TabHeading) === initialTabParam
    )
    : null;

  const [selectedTab, setSelectedTabState] = useState(initialTab);

  /**
   * @param {string} tabHeading
   */
  const updateSelectedTabParam = (tabHeading) => {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('selectedTab', tabHeading);
    window.history.pushState({}, '', newUrl);
  };

  /**
   * @param {number} index
   * @param {string} tabHeading
   */
  const setSelectedTab = (index, tabHeading) => {
    setSelectedTabState(index);
    updateSelectedTabParam(sanitizeUrlParam(tabHeading));
  };

  useEffect(() => {
    if (MainContent[0] !== null && initialTab === null) {
      setSelectedTab(0, MainContent[0].TabHeading);
    }
  }, []);

  return (
    <div className="row">
      {isMediumViewport() ? (
        <div className="ids-select-wrapper">
          <select
            id="select-1"
            className="ids-select"
            name="options"
            onChange={(e) => setSelectedTab(MainContent.findIndex((block) => sanitizeUrlParam(block.TabHeading) === e.target.value), e.target.value)}
            value={selectedTab !== null ? sanitizeUrlParam(MainContent[selectedTab].TabHeading) : ""}
          >
            {MainContent.map((block, index) => (
              <option key={index} value={sanitizeUrlParam(block.TabHeading)}>
                {block.TabHeading}
              </option>
            ))}
          </select>
        </div>
      ) : (
        <div className="ids-tabs" role="tablist">
          {MainContent.map((block, index) => (
            <button
              key={index}
              role="tab"
              id={`tab-${index}`}
              aria-controls={`tabpanel-${index}`}
              className={`ids-tab ${index === selectedTab ? 'ids-tab--selected' : ''
                }`}
              onClick={() => {
                setSelectedTab(index, block.TabHeading);
              }}
              aria-selected={index === selectedTab}
            >
              {block.TabHeading}
            </button>
          ))}
        </div>
      )}
      <div className="ids-tab-panels">
        {MainContent.map((block, index) => (
          <div
            key={index}
            role="tabpanel"
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            className={`ids-tab-panel ${index === selectedTab ? 'ids-tab-panel--selected' : ''
              }`}
          >
            <ContentAreaRenderer
              blocks={block}
              propertyName="MainContent"
              currentPageProps={props}
            >
              <BlockTypeRenderer Blocks={Blocks} />
            </ContentAreaRenderer>
          </div>
        ))}
      </div>
    </div>
  );
};
